import appStore from 'store';
import LANGUAGE from 'common/languages_code';

const store = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {}
}

appStore.registerModule('StrategyManage', store);
